import baseEditForm from 'formiojs/components/panel/Panel.form';
import BaseEditConditionalComponents from '../../../configuration-components/base-widget-configuration/base.edit.conditional.components';
import LenderOnly from '../../../configuration-components/base-widget-configuration/display/lender-only-field-checkbox';
import HideInPdf from '../../../configuration-components/base-widget-configuration/display/hide-in-pdf-checkbox';
import ForceRenderInPdf from '../../../configuration-components/base-widget-configuration/display/force-render-in-pdf-checkbox';

export default function (...extend: any[]) {
	return baseEditForm(
		[
			{
				key: 'display',
				components: [HideInPdf, LenderOnly, ForceRenderInPdf]
			},
			{
				key: 'api',
				ignore: true
			},
			{
				key: 'conditional',
				components: BaseEditConditionalComponents
			},
			{
				key: 'logic',
				ignore: true
			},
			{
				key: 'layout',
				ignore: true
			}
		],
		...extend
	);
}
